import SubTable from 'src/components/commons/subTable';
import PageContainer from 'src/components/pageContainer/PageContainer';
import { CustomLoadingModal } from 'src/components/commons/customModal';
import useUnitOfMeasurementTable from './hooks/useUnitOfMeasurementTable';
import StyleInfinityScroll from '../../../../styles/StyleInfinityScroll.style';

const TabUnitOfMeasurements = () => {
  const {
    dataSource,
    columns,
    spinning,
    newRecord,
    setColumns,
    onListRender,
    autoCompleteFieldSearch,
    handleFilterChange,
    handleDeleteRows,
    postNewRecord,
    resetNewRecord,
    handleUpdateRows,
    handleNewRecord,
    handleClearFilter,
  } = useUnitOfMeasurementTable();

  return (
    <>
      {spinning && <CustomLoadingModal modalStatus />}
      <PageContainer margin='2rem'>
        <StyleInfinityScroll>
          <SubTable
            data={dataSource || []}
            columns={columns}
            setColumns={setColumns}
            onListRender={onListRender}
            onFilterChange={handleFilterChange}
            autocompleteFieldProvider={autoCompleteFieldSearch}
            columnFilterShown
            scroll={{ y: '60vh', x: '90vw' }}
            clearFilter={handleClearFilter}
            actionCell={['delete']}
            headerActions={['filter', 'edit', 'delete']}
            id='unit-of-measurement-table'
            showOptionFilterLeft={false}
            allowGlobalEditActive
            activeOnSelectRowsDisableEdit
            total
            showAutoIncrement
            newRecord={newRecord}
            resetNewRecord={resetNewRecord}
            handleUpdateRows={handleUpdateRows}
            onDeleteClick={handleDeleteRows}
            saveNewRecord={postNewRecord}
            postData={handleNewRecord}
          />
        </StyleInfinityScroll>
      </PageContainer>
    </>
  );
};

export default TabUnitOfMeasurements;
